export const REGIONAL_TIDE_ALERT_ERROR = "regional_tide_planning_only";
export const REGIONAL_TIDE_ALERT_MESSAGE =
  "This location has regional tide predictions for planning only. Tide-trigger alerts are not available until local tide timing is validated. Choose another alert type.";
